<template>
  <div class="view contextual">
    <div class="filters">
      <StoreSelect @storeSelected="storeSelected" />
      <div class="actions-bar">
        <a
          class="button white sm download umami--click--descarga-portal"
          v-bind:href="downlonadLink"
        >
          <i class="icon ico-download"></i>
          <p>{{ downloadTitle }}</p>
        </a>
      </div>
    </div>
    <AmountCard
      style="grid-column-start: 2"
      @changeRange="showData"
      title="Hoy"
      :today="today"
      :initRange="today"
      :initPrevious="yesterday"
      :endPrevious="yesterday"
      :selectedRange="selectedRange"
      :store_id="store_id"
      tip="Conexiones realizadas el día de hoy, por hora, comparadas con las conexiones totales del día de ayer."
    />
    <AmountCard
      @changeRange="showData"
      title="Últimos 7 días"
      :today="yesterday"
      :initRange="initRange"
      :initPrevious="initPrevious"
      :endPrevious="endPrevious"
      :selectedRange="selectedRange"
      :store_id="store_id"
      tip="Conexiones realizadas durante los últimos 7 días, comparadas con las conexiones totales de los 7 días previos."
    />
    <AmountCard
      @changeRange="showData"
      class="desktop"
      title="Últimos 15 días"
      :today="yesterday"
      :initRange="initRange15"
      :initPrevious="initPrevious15"
      :endPrevious="endPrevious15"
      :selectedRange="selectedRange"
      :store_id="store_id"
      tip="Conexiones realizadas durante los últimos 15 días, comparadas con las conexiones totales de los 15 días previos."
    />
    <AmountCard
      @changeRange="showData"
      class="desktop"
      title="Últimos 30 días"
      :today="yesterday"
      :initRange="initRange30"
      :initPrevious="initPrevious30"
      :endPrevious="endPrevious30"
      :selectedRange="selectedRange"
      :store_id="store_id"
      tip="Conexiones realizadas durante los últimos 30 días, comparadas con las conexiones totales de los 30 días previos."
    />
    <div class="logins-connections">
      <LoginGraphCard
        class="logins"
        style="grid-column-start: 2"
        title="Inicios de sesión"
        tip="Muestra la cantidad de sesiones iniciadas de acuerdo a la red WiFi a la que se conectó el usuario dependiendo de su perfil, para el período seleccionado."
        :sm="true"
        :detailed="socialNetworkChartData"
        :detailedNames="socialNetworkSSID"
        :loader="RRSSLoaded"
        :icons="socialNetworkSSIDIcons"
      />
      <BarGraphCard
        class="connections-time"
        title="Conexiones periodo seleccionado"
        tip="Conexiones del período seleccionado, por día. En caso de que el período seleccionado sea 'Hoy', muestra las conexiones por hora del día de hoy."
        :data="connectionBarChart"
        :periodItems="periods"
        :loader="connectionsLoaded"
        :xl="true"
      />
    </div>
    <div class="devices-grid">
      <GraphCard
        class="devices"
        style="grid-column-start: 2"
        title="Dispositivos"
        tip="Muestra el total de dispositivos nuevos y dispositivos recurrentes para el período seleccionado. Un usuario se considera nuevo si sólo se ha conectado una vez dentro del período seleccionado, y recurrente en caso de que se haya conectado más de una vez en el mismo período."
        :sm="true"
        :detailed="[totalRecurrent, totalNotRecurrent]"
        :detailedNames="['Recurrentes', 'Nuevos']"
        :loader="recurrentLoaded"
      />

      <BarGraphCard
        class="devices-time"
        title="Dispositivos periodo seleccionado"
        tip="Muestra el total de dispositivos nuevos y dispositivos recurrentes para el período seleccionado, por día. En caso de que el período seleccionado sea ‘Hoy’, muestra la información por hora del día de hoy."
        :data="recurrentChartData"
        :periodItems="periods"
        :loader="recurrentLoaded"
        :responsive="true"
      />
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
import _ from 'lodash'
import AmountCard from '@/components/cards/AmountCard'
import GraphCard from '@/components/cards/GraphCard'
import BarGraphCard from '@/components/cards/BarGraphCard'
import StoreSelect from '@/components/StoreSelect'
import LoginGraphCard from '@/components/cards/LoginGraphCard'

export default {
    name : 'satari',
    data: function(){
        return {
            periods: [],
            connectionBarChart: [],
            totalVisitors: 0,
            totalPassersBy: 0,
            totalConnections: 0,
            connectionsLoaded: false,
            totalRecurrent: 0,
            totalNotRecurrent: 0,
            recurrentChartData: [],
            recurrentLoaded: false,
            store_id: 999999,
            initPrevious: moment().subtract(14,'d').format('YYYY-MM-DD'),
            endPrevious: moment().subtract(8, 'd').format('YYYY-MM-DD'),
            initRange: moment().subtract(7,'d').format('YYYY-MM-DD'),
            initRange7: moment().subtract(7, 'd').format('YYYY-MM-DD'),
            initRange15: moment().subtract(15, 'd').format('YYYY-MM-DD'),
            initPrevious15: moment().subtract(30, 'd').format('YYYY-MM-DD'),
            endPrevious15: moment().subtract(16, 'd').format('YYYY-MM-DD'),
            initRange30: moment().subtract(30, 'd').format('YYYY-MM-DD'),
            initPrevious30: moment().subtract(60, 'd').format('YYYY-MM-DD'),
            endPrevious30: moment().subtract(31, 'd').format('YYYY-MM-DD'),
            today: moment().format('YYYY-MM-DD'),
            yesterday: moment().subtract(1, 'd').format('YYYY-MM-DD'),
            selectedRange: this.initRange,
            csvFileUrl: process.env.VUE_APP_ANALYTICS_HOST,
            csvExportData: [],
            csvExportDataTotal: [],
            csvExportDataConnections: [],
            csvExportDataSumConnection: 0,
            socialNetworkChartData: [],
            socialNetworkSSID: process.env.VUE_APP_SSID.split(","),
            socialNetworkSSIDColors: process.env.VUE_APP_SSID_COLORS.split(","),
            socialNetworkSSIDIcons: process.env.VUE_APP_SSID_ICONS.split(","),
            RRSSLoaded: false,
            downlonadLink: "",
            downloadTitle: "Descarga últimos 30 días",
        }
    },
    components: {
        AmountCard,
        GraphCard,
        BarGraphCard,
        LoginGraphCard,
        StoreSelect
    },
    mounted: function(){
        this.$store.dispatch("auth/setActive", "wifi");
        this.selectedRange = this.today
        // https://petrobras-csvreport.getnotros.com/csv_reports/esmax_store_999999_sesiones_26_10_2020_01_11_2020.csv
        let downloadInitDate = moment().subtract(1,'d').format('DD-MM-YYYY')
        this.downlonadLink = "https://notros-clientes.s3.us-east-1.amazonaws.com/"+ process.env.VUE_APP_CLIENT_NAME_S3 +"/reports/"+downloadInitDate+"-"+process.env.VUE_APP_CLIENT_NAME+"-sessions.csv"
    },
    methods: {
      thousandseparatos: function(num){
        var num_parts = num.toString().split(".");
        num_parts[0] = num_parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        return num_parts.join(".");
      },
      // csvCreateData: function(){

      //   let headers = {
      //     'Authorization': 'ZGFuaWVsQGZyZWRlc0BlbHVuOm51YmU1NDMyMTBuMHVzM3N3MW5kMHJ6'
      //   }
      //   axios.get(process.env.VUE_APP_ANALYTICS_HOST+"/api/recurrents/?store_id="+this.store_id+"&init_date="+this.initRange+"&end_date="+this.yesterday, {
      //     headers: headers
      //   })
      //     .then((res) => {
      //       console.log(res.data)
      //       this.csvExportData = res.data
      //     })
      //     .then(() => {
      //       axios.get(process.env.VUE_APP_ANALYTICS_HOST+"/api/total_recurrents/?store_id="+this.store_id+"&init_date="+this.initRange+"&end_date="+this.yesterday, {
      //         headers: headers
      //       }).then((res) => {
      //         console.log(res.data)
      //         this.csvExportDataTotal = res.data
      //       })
      //       .then(() => {
      //         axios.get(process.env.VUE_APP_ANALYTICS_HOST+"/api/sessions/?init_date="+this.initRange+"&end_date="+this.yesterday+"&store_id="+this.store_id, {
      //           headers: headers
      //         })
      //           .then((res) => {
      //               console.log(res.data)
      //               this.csvExportDataConnections = res.data
      //               _.each(res.data, (value, index) => {
      //                   this.csvExportDataSumConnection = this.csvExportDataSumConnection + value.not_customer
      //               })
      //               this.csvExport()
      //           })
      //           .catch((err) => {
      //               console.log(err)

      //           })
      //       })
      //       .catch((err) => {
      //           console.log(err)
      //       })
      //     })
      //     .catch((err) => {
      //       console.log(err)
      //   })
      // },
      // csvExport: function() {


      //   let periodRecurrentNotrecurrent = []

      //   _.each(this.csvExportData, (value) => {
      //     let period = {}
      //     period["Período"] = value.period
      //     period["Dispositivos_recurrentes"] = this.thousandseparatos(value.recurrent)
      //     period["Dispositivos_nuevos"] = this.thousandseparatos(value.not_recurrent)

      //     _.each(this.csvExportDataConnections, (connection) => {
      //       if (period["Período"] === connection.period){
      //           period["Conexiones"] = this.thousandseparatos(connection.not_customer+connection.customer)
      //       }
      //     })
      //     periodRecurrentNotrecurrent.push(period)

      //   })

      //     let spaceperiod = {}
      //     spaceperiod["Período"] = ""
      //     spaceperiod["Dispositivos_recurrentes"] = ""
      //     spaceperiod["Dispositivos_nuevos"] = ""
      //     spaceperiod["Conexiones"] = ""
      //     periodRecurrentNotrecurrent.push(spaceperiod)

      //     let totalperiod = {}
      //     totalperiod["Período"] = "Total"
      //     totalperiod["Dispositivos_recurrentes"] = this.thousandseparatos(this.csvExportDataTotal[0].recurrent)
      //     totalperiod["Dispositivos_nuevos"] = this.thousandseparatos(this.csvExportDataTotal[0].not_recurrent)
      //     totalperiod["Conexiones"] = this.thousandseparatos(this.csvExportDataSumConnection)
      //     periodRecurrentNotrecurrent.push(totalperiod)

      //   let csvContent = "data:text/csv;charset=utf-8,";
      //   csvContent += [
      //     Object.keys(periodRecurrentNotrecurrent[0]).join(";"),
      //     ...periodRecurrentNotrecurrent.map(item => Object.values(item).join(";"))
      //   ]
      //     .join("\n")
      //     .replace(/(^\[)|(\]$)/gm, "");

      //   const data = encodeURI(csvContent);
      //   const link = document.createElement("a");
      //   link.setAttribute("href", data);
      //   link.setAttribute("download", "export.csv");
      //   link.click();
      // },
      storeSelected: function(value){
        this.store_id = value
        document.getElementsByClassName("card-data sm active")[0].click()
      },
      showData: function(init, end, barChart){
        this.connectionsLoaded = false
        this.recurrentLoaded = false
        this.RRSSLoaded = false

        this.selectedRange = init

        let connectedChartData = [{
          'name': 'Conexiones',
          'data': []
        }]
        let periods = []
        let sumConnection = 0

        _.each(barChart, (value) => {
          periods.push(value.period)
          connectedChartData[0].data.push(value.not_customer + value.customer)
          sumConnection = sumConnection + value.not_customer + value.customer
        })

        this.connectionBarChart = connectedChartData
        this.totalConnections = sumConnection
        this.recurrentData(init, end)

        // TODO: Revisar esto
        if (process.env.VUE_APP_CLIENT_NAME === 'duoc') {
          this.RRSSDataDuoc(init, end)
        } else {
          this.RRSSData(init, end)
        }

        this.periods = periods
        setTimeout(() => this.connectionsLoaded = true, 300)

      },
      recurrentData: function(init, end){
        let headers = {
          'Authorization': 'ZGFuaWVsQGZyZWRlc0BlbHVuOm51YmU1NDMyMTBuMHVzM3N3MW5kMHJ6'
        }
        axios.get(process.env.VUE_APP_ANALYTICS_HOST+"/api/recurrents/?store_id="+this.store_id+"&init_date="+init+"&end_date="+end, {
          headers: headers
        })
          .then((res) => {
            let recurrentData = [
              {
                'name': 'Recurrentes',
                'data': []
              },
              {
                'name': 'Nuevos',
                'data': []
              }
            ]
            _.each(res.data, (value) => {
              recurrentData[0].data.push(value.recurrent)
              recurrentData[1].data.push(value.not_recurrent)
            })

            this.recurrentChartData = recurrentData

          })
          .then(() => {
            axios.get(process.env.VUE_APP_ANALYTICS_HOST+"/api/total_recurrents/?store_id="+this.store_id+"&init_date="+init+"&end_date="+end, {
              headers: headers
            }).then((res) => {
              this.totalRecurrent = res.data[0].recurrent
              this.totalNotRecurrent = res.data[0].not_recurrent
              this.recurrentLoaded = true
            })
          })
          .catch((err) => {
            this.recurrentLoaded=true
            console.log(err)
        })
      },
      RRSSData: function(init, end){
        let headers = {
          'Authorization': 'ZGFuaWVsQGZyZWRlc0BlbHVuOm51YmU1NDMyMTBuMHVzM3N3MW5kMHJ6'
        }
        axios.get(process.env.VUE_APP_ANALYTICS_HOST+"/api/sessions_by_ssid/?store_id="+this.store_id+"&init_date="+init+"&end_date="+end, {
          headers: headers
        })
          .then((res) => {
            let RRSSDataList = [{
              'name':'Total',
              'data':[],
            }]
            const respuestaApi = res.data;
            // +"/api/sessions_by_ssid/?store_id="+this.store_id+"&init_date="+init+"&end_date="+end

            // var cont = 0;
            console.log(res.data);

            var tempSocialNetworkSSID = this.socialNetworkSSID.slice();

            // Calcular el total de conteos
            const total = respuestaApi.reduce((acc, item) => acc + item.count, 0);

            // Generar los datos para RRSSDataList
            tempSocialNetworkSSID.forEach((node_id, index) => {
              const foundItem = respuestaApi.find(item => item.node_id === node_id);
              const count = foundItem ? foundItem.count : 0;
              const percentage = total === 0 ? 0 : (100 * count) / total;
              const aux = {
                'x': node_id,
                'fillColor': "#" + this.socialNetworkSSIDColors[index],
                'y': percentage
              };
              RRSSDataList[0].data.push(aux);
            });
            if(tempSocialNetworkSSID.length == 1 && total > 0){
              const aux = {
                'x': tempSocialNetworkSSID[0],
                'fillColor': "#" + this.socialNetworkSSIDColors[0],
                'y': 100
              };
              RRSSDataList[0].data = [aux]
            }

            console.log(RRSSDataList);
            this.socialNetworkChartData = RRSSDataList;
            this.RRSSLoaded = true;

          })
          .catch((err) => {
            this.RRSSLoaded = true
            this.socialNetworkChartData=[]
            console.log(err)
        })
      },
      RRSSDataDuoc: function(init, end){
        let headers = {
          'Authorization': 'ZGFuaWVsQGZyZWRlc0BlbHVuOm51YmU1NDMyMTBuMHVzM3N3MW5kMHJ6'
        }
        axios.get(process.env.VUE_APP_ANALYTICS_HOST+"/api/sessions_by_portal/?store_id="+this.store_id+"&init_date="+init+"&end_date="+end, {
          headers: headers
        })
          .then((res) => {
            
            let RRSSData = [
              {
                "name": "Total",
            "data": [
                {
                  "x": "Academic",
                  "fillColor": "#720acb",
                  // "y": 10,
                },
                {
                  "x": "Invitados",
                  "fillColor": "#f1840a",
                  // "y": 20,
                },
                
              ]
            }
          ]
          
          let academicPercentage = 0
          let invitadosPercentage = 0
          
          let academicTotal = 0
          let invitadosTotal = 0
          
          _.each(res.data, (value) => {
            academicTotal = academicTotal + value.not_customer_duoc_academic
            invitadosTotal = invitadosTotal + value.not_customer_duoc_invitados
          })
          
          academicPercentage = (100*academicTotal)/(academicTotal+invitadosTotal)
          invitadosPercentage = (100*invitadosTotal)/(academicTotal+invitadosTotal)
          
          RRSSData[0].data[0]['y'] = academicPercentage
          RRSSData[0].data[1]['y'] = invitadosPercentage
          
          this.socialNetworkChartData = RRSSData
          this.RRSSLoaded = true
          // console.log(RRSSData)
          
        })
          .catch((err) => {
            this.RRSSLoaded = true
            this.socialNetworkChartData=[]
            console.log(err)
            // console.log("error redes ")
            // console.log(this.socialNetworkChartData)
            // console.log("fin error")
            
        })
      }
    }
}
</script>
<style lang="sass">
.view.contextual
  .filters
    grid-column: 2/6
    display: flex
    justify-content: space-between
    @include mobile
      flex-direction: column
      grid-column: 2/4
    @include mobile-landscape
      grid-column: 2/4
    @include tablet-landscape
      grid-column: 2/6
.view.contextual
  @include mobile-landscape
    grid-template-column: 8px repeat(2,minmax(0,1fr)) 8px
  .actions-bar
    display: flex
    align-items: center
    grid-column-start: 4
    grid-column-end: 6
    justify-content: flex-end
    @include mobile
      grid-column-start: 2
      grid-column-end: 4
    @include mobile-landscape
      grid-column: 2/4
    .download
      width: 280px
      @include mobile
        width: 100%
  .desktop
    @include mobile-landscape
      display: none
  .card-data.xl
    @include mobile-landscape
      grid-column: 2/4
  .devices-grid,.logins-connections
    grid-column: 2/6
    display: flex
    flex-direction: row
    @include mobile
      grid-column: 2/4
      flex-direction: column
    @include mobile-landscape
      grid-column: 2/4
    .devices,.logins
      grid-column-start: 2
      width: 50%
      flex-grow: 1
      @include mobile
        width: 100%

    .devices-time,.connections-time
      margin-left: 8px
      flex-grow: 3
      @include mobile
        margin-left: 0
        margin-top: 8px
</style>
